import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import RecipientSearch from './RecipientSearch';
import username from 'flarum/common/helpers/username';
import Stream from 'flarum/common/utils/Stream';
import withAttr from 'flarum/common/utils/withAttr';
import app from 'flarum/forum/app';
import resolveConversationsRecipient from '../utils/resolveConversationsRecipient';
export default class StartConversationModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    app.cache.conversationsRecipient = resolveConversationsRecipient(this.attrs.recipient ?? null);
    this.conversations = this.attrs.conversations ?? [];
    this.already = false;
    this.messageContent = Stream('');
  }
  title() {
    return app.translator.trans('neoncube-private-messages.forum.modal.title');
  }
  className() {
    return 'StartConversationModal Modal--medium';
  }

  // Flarum 2 Modal is no longer a form. F1 already supplies its own form
  // and does not call this wrapper hook.
  wrapper(children) {
    return m("form", {
      onsubmit: this.onsubmit.bind(this)
    }, children);
  }
  content() {
    return [m("div", {
      className: "Modal-body",
      onclick: e => e.stopImmediatePropagation()
    }, this.already ? [m("h2", null, app.translator.trans('neoncube-private-messages.forum.modal.already', {
      username: username(this.recpient)
    })), m("h2", null, app.translator.trans('neoncube-private-messages.forum.modal.copied', {
      username: username(this.recpient)
    }))] : m("div", null, m("div", {
      class: "helpText"
    }, app.cache.conversationsRecipient !== null ? app.translator.trans('neoncube-private-messages.forum.modal.help_start', {
      username: username(app.cache.conversationsRecipient)
    }) : app.translator.trans('neoncube-private-messages.forum.modal.help')), m("div", {
      className: "AddRecipientModal-form"
    }, m(RecipientSearch, {
      state: app.search.state || app.search
    }), app.cache.conversationsRecipient !== null ? m("div", {
      className: "AddRecipientModal-form-submit"
    }, m("textarea", {
      value: this.messageContent(),
      oninput: withAttr('value', this.messageContent),
      placeholder: app.translator.trans('neoncube-private-messages.forum.chat.text_placeholder'),
      rows: "3"
    }), m(Button, {
      type: "submit",
      className: "Button Button--primary",
      disabled: !this.messageContent()
    }, app.translator.trans('neoncube-private-messages.forum.modal.submit'))) : '')))];
  }
  onsubmit(e) {
    e.preventDefault();
    const recipient = app.cache.conversationsRecipient;
    this.recpient = recipient;
    app.cache.conversationsRecipient = null;
    const draft = this.messageContent();
    const onResolved = this.attrs.onConversationResolved;
    app.store.createRecord('conversations').save({
      messageContents: draft,
      recipient: recipient.id()
    }).then(conversation => {
      if (onResolved) {
        if (!conversation.notNew()) {
          this.conversations.push(conversation);
          m.redraw();
          app.modal.close();
          onResolved(conversation, {
            created: true,
            draft: null
          });
        } else {
          app.modal.close();
          onResolved(conversation, {
            created: false,
            draft
          });
        }
        return;
      }
      if (!conversation.notNew()) {
        this.conversations.push(conversation);

        // const preconv = app.session.user.conversations();
        // preconv.push(conversation);
        // app.session.user.conversations = Stream(preconv);

        // Need to review Github diff after this point
        m.redraw();
        app.modal.close();
      } else {
        let input = document.createElement('textarea');
        document.body.appendChild(input);
        input.value = this.messageContent();
        input.focus();
        input.select();
        document.execCommand('Copy');
        input.remove();
        this.already = true;
        m.redraw();
      }
    });
  }
}
flarum.reg.add('flatrate-private-messages-bridge', 'forum/components/StartConversationModal', StartConversationModal);